import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { fromNowDetailed } from '../utils/day';

interface CountdownProps {
  deadline: Date;
  isPPV3?: boolean;
}

export const Countdown: FunctionComponent<CountdownProps> = ({ deadline, isPPV3 }) => {
  const { t } = useTranslation('sharedComponents');
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    setInterval(() => {
      setCountdown(fromNowDetailed(deadline));
    }, 1000);
  }, []);

  return isPPV3 ? (
    <CountDown>
      <span>{`${countdown.days < 10 ? '0' : ''}${countdown.days}`}</span> <span>:</span>
      <span>{`${countdown.hours < 10 ? '0' : ''}${countdown.hours}`}</span> <span>:</span>
      <span>{`${countdown.minutes < 10 ? '0' : ''}${countdown.minutes}`}</span> <span>:</span>
      <span>{`${countdown.seconds < 10 ? '0' : ''}${countdown.seconds}`}</span>
    </CountDown>
  ) : (
    <CountDownContainer>
      <Metric>
        <span className={'amount'}>{`${countdown.days < 10 ? '0' : ''}${countdown.days}`}</span>
        <span>{t('shared.countdown.days')}</span>
      </Metric>
      <Metric>
        <span className={'amount'}>{`${countdown.hours < 10 ? '0' : ''}${countdown.hours}`}</span>
        <span>{t('shared.countdown.hours')}</span>
      </Metric>
      <Metric>
        <span className={'amount'}>{`${countdown.minutes < 10 ? '0' : ''}${countdown.minutes}`}</span>
        <span>{t('shared.countdown.minutes')}</span>
      </Metric>
      <Metric>
        <span className={'amount'}>{`${countdown.seconds < 10 ? '0' : ''}${countdown.seconds}`}</span>
        <span>{t('shared.countdown.secondes')}</span>
      </Metric>
    </CountDownContainer>
  );
};

const CountDown = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 1180px) {
    font-size: 12px;
    line-height: 15px;
    font-family: 'Styrene Medium', sans-serif;
    color: #fcc443;
    background: #323232;
  }
`;

const CountDownContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
  margin: 0 10px;

  > span {
    margin-top: -22px;
  }

  @media (max-width: 1024px) {
    column-gap: 2px;
  }
`;

const Metric = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffc74a;
  border-radius: 5px;
  font-weight: bold;
  color: #313131;
  height: 37px;
  width: 65px;
  justify-content: center;
  user-select: none;

  @media (max-width: 1024px) {
    width: 30px;
    height: 30px;
  }

  > span:not(.amount) {
    font-size: 10px;
    font-weight: normal;

    @media (max-width: 1024px) {
      display: none;
    }
  }

  .amount {
    font-size: 16px;

    @media (max-width: 1024px) {
      font-size: 14px;
    }

    > span {
      color: white;
      font-weight: lighter;
    }
  }
`;
